
import { defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import { handleCatchErrorCustom, currency } from '@/utils/general-utils';

import { AxiosError } from 'axios';

export default defineComponent({
  name: 'Validate QR',
  props: {
    token: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup() {
    interface Business {
      product: string;
      credit: string;
      capital_value: string;
      others: string;
      interests: string;
      current_debt_value: string;
    }

    interface Fees {
      fee_number: string;
      fee_value: string;
      fee_capita: string;
      fee_life_insurance: string;
      fee_outlay_administration: string;
      fee_date_payment: string;
      fee_state: string;
    }
    type PazYSalvo = {
      fecha: string;
      id: string;
      identificacion: string;
      nombre: string;
      portfolio: string;
      typeDocument: string;
    };

    type AgreementStatus = {
      IDAcuerdo: string;
      Vendedor: string;
      fecha: string;
      id: string;
      identificacion: string;
      nombre: string;
      typeDocument: string;
      fees: Array<Fees>;
    };

    type ObligationWithOuthAgreement = {
      bank_name: string;
      business: Array<Business>;
      fecha: string;
      identificacion: string;
      nombre: string;
      typeDocument: string;
    };

    const store = useStore();
    const route = useRoute();
    const loading = ref<boolean>(false);
    const errorOccurred = ref<boolean>(false);
    let dataQr = ref<PazYSalvo | AgreementStatus | ObligationWithOuthAgreement>(
      Object.create({})
    );

    const getVelidateQr = async (hash: string | string[]) => {
      try {
        loading.value = true;
        dataQr.value = await store.dispatch('validateQR', hash);
      } catch (error) {
        errorOccurred.value = true;
        handleCatchErrorCustom(
          error as AxiosError,
          'Se produjo un error al validar el QR.'
        );
      } finally {
        loading.value = false;
        //return;
      }
    };

    onMounted(async () => {
      const hash = route.params.hash;
      getVelidateQr(hash);
    });

    return {
      loading,
      dataQr,
    };
  },
});
